export const StoreEndpoints = {
  root: '/stores',
  orders: '/store/orders',
  products: '/store/products',
  dashboard: '/store/dashboard',
  locations: '/store/locations',
}
